import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.json'
import ko from './ko.json'

Vue.use(VueI18n)

const messages = { en, ko }

const i18n = new VueI18n({
    locale: 'ko',
    fallbackLocale: 'ko',
    messages,
})

export default i18n
